import { defineMessages } from 'react-intl';

export const i18n: {
	verifiedIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	verifiedIconTooltipMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	verifiedIconLabel: {
		id: 'search-page.verified-icon-label',
		defaultMessage: 'Verified',
		description:
			'Accessible label for the verified icon shown next to a search result that has been verified by a page owner or admin.',
	},
	verifiedIconTooltipMessage: {
		id: 'search-page.verified-icon-tooltip-message',
		defaultMessage: 'This page has been verified by an owner or admin.',
		description:
			'Tooltip text shown when hovering over the verified icon on a search result, explaining that the page has been verified by an owner or admin.',
	},
});
